module.exports = __webpack_public_path__ + "static/media/Valk4.7a783a6c.png";